import FeedbackResContainer from "./FeedbackResContainer";
import ViewMoreFeedbackContainer from "./ViewMoreFeedbackContainer";

export {
    FeedbackResContainer,
    ViewMoreFeedbackContainer,
}